import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper} from "@material-ui/core";
import { Title } from "App/Component/ui";

import { FormPo } from "./ui";
import { FormContext, FormProvider } from "./context/FormContext";
import {
  FORM_RESET_STATE_WMS_PO,
  getPoListById,
  RenderListPo,
} from "./helpers";
import { RESET_STATE_PO_BARANG } from "./ui/DataBarang/helpers";
import { WMS_FA_PO } from "App/constants";
import { isNull } from "App/utils/helpers";
import Export from "./ui/Export";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function PurchaseOrderLogistik(props) {
  const classes = useStyles();
  return (
    <FormProvider
      data={
        isNull(props?.data)
          ? FORM_RESET_STATE_WMS_PO
          : props?.menu === WMS_FA_PO
          ? props?.data
          : FORM_RESET_STATE_WMS_PO
      }
    >
      <div className={classes.root}>
        <Title title={"Purchase Order (PO) Fixed Assets"} />
        <Paper className={classes.paper}>
          <RenderContent classes={classes} data={props?.data} />
        </Paper>
      </div>

      <Export />
    </FormProvider>
  );
}

const RenderContent = ({ classes, data }) => {
  const [formBarang, setFormBarang] = useState(RESET_STATE_PO_BARANG);
  const [listPO, setListPO] = useState([]);
  const {setValidasi} = useContext(FormContext);

  useEffect(() => {
    setNewDataPoList(data.idpo);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPoList = async (idPo) => {
    if (!isNull(data)) {
      await getListPo(idPo);
    } else if (!isNull(idPo)) {
      await getListPo(idPo);
    }
  };

  const getListPo = async (idPo) => {
    if (!isNull(idPo)) {
      const res = await getPoListById(idPo);
      if (res.state) {
        setListPO(res.data.detail);
        setValidasi(res.validasi);
      } else {
        setListPO([]);
      }
    }
  };

  return (
    <>
      <FormPo
        setListPO={setListPO}
        listPO={listPO}
        setNewDataPoList={setNewDataPoList}
      />
      <div className="mt-2"></div>
      <RenderListPo
        classes={classes}
        formBarang={formBarang}
        setFormBarang={setFormBarang}
        listPO={listPO}
        setListPO={setListPO}
        setNewDataPoList={setNewDataPoList}
      />
    </>
  );
};
